(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('selectStyled', select);

    select.$inject = ['$filter', '$timeout', 'modals', '$state', '$document'];

    function select($filter, $timeout, modals, $state, $document) {
        
        var directive = {
            link: link,
            require: ['?^form'],
            restrict: 'EA',
            templateUrl: 'app/views/directives/select.html',
            scope: {
                data: '=', //List of elements
                ngModel: '=?', //Item selected
                ngModelId: '=?',
                idField: '@?', //Default: 'id'
                displayField: '@?', //Default: 'nombre'
                displayIdField: '@?',
                displayExtraField: '@?',
                labelText: '@?',
                isLoading: '=?', //Expression to display the loading message
                loadingText: '@?', //Default: 'Cargando datos...'
                emptyText: '@?', //Default: 'No hay elementos'
                ngChange: '&?', //Callback function when ngModel changes
                onChange: '&?', //New callback(we need to change ngChange with this to be able to make ngModel optional)
                ngDisabled: '=?',
                autofocus: '<',
                defaultOpt: '@?',
                placeholder: '@?',
                ngRequired: '<',
                onBeforeChange: '&?',

                //Entity create/link
                entityLink: '@?', //The final link will be: [entityLink + '?id=' + selectedItemId]
                entityCreate: '@?', //The string referencing the modal on the service
                entityEdit: '@?', //The string referencing the modal on the service
                entityCreateCall: '&?',
                entityCreateCallback: '&?',
                entityEditCallback: '&?'
            }
        };
        return directive;

        /* jshint maxstatements:false, maxcomplexity:false */
        function link(scope, element, attrs, ctrls) {
            var mainElement = element[0].children[1];
            scope.isOpen = false;
            scope.filter = { text: '' };

            if(!scope.idField){ scope.idField = 'id'; }
            if(!scope.displayField){ scope.displayField = 'nombre'; }
            if(!scope.loadingText){ scope.loadingText = 'Cargando datos...'; }
            if(!scope.emptyText){ scope.emptyText = 'No hay elementos'; }
            if(!scope.placeholder){ scope.placeholder = ''; }
            if(!scope.defaultOpt){ scope.defaultOpt = null; }
            if(!scope.autofocus){ scope.autofocus = false; } else { scope.autofocus = true;}
            if(!scope.ngRequired){ scope.ngRequired = false; } else { scope.ngRequired = true;}

            if(!scope.data) { scope.data = []; }
            if(!scope.ngModel) { scope.ngModel = {}; }

            
            scope.defaultItem = {};
            scope.defaultItem[scope.idField] = null;
            scope.defaultItem[scope.displayField] = scope.defaultOpt;
            scope.defaultItem[scope.displayIdField] = null;

            scope.emptyItem = {};
            scope.emptyItem[scope.idField] = null;
            scope.emptyItem[scope.displayField] = null;
            scope.emptyItem[scope.displayIdField] = null;
            
            scope.isSelected = function(){
                if(!scope.ngModel){ return false; }
                if(scope.ngModel[scope.idField] == null){ return false; }
                return true;
            };
            scope.itemClick = function(item){
                selectItem(item);
                close();
            };
            
            scope.clearItem = function(item){
                if (scope.ngDisabled) { return; }
                selectItem(scope.emptyItem);
            };

            scope.filterData = function () {
                //console.log(scope.labelText + 'filterData');

                if (!scope.data || scope.data.length === 0) { 
                    //console.log('entra empty data');
                    scope.ngModel = scope.emptyItem; 
                    return; 
                }
                
                if(scope.labelText == 'Aplicable a') {
                    // console.log('entra en');
                }

                if(scope.ngModelId){
                    if(scope.labelText == 'Aplicable a') {
                        // console.log('es de entidad');
                    }

                    var found = $filter('filter')(scope.data, {[scope.idField]: scope.ngModelId});
                    if (found.length === 0) {
                        // console.log('ng modelId ' + scope.ngModelId + ' not found');
                        scope.ngModel = scope.emptyItem; 
                    }
                    else { 
                        scope.ngModel = found[0]; 
                    }
                }

                //Filtered data by name
                var filterInfo = {};
                filterInfo[scope.displayField] = scope.filter.text;
                if(scope.displayIdField){
                    filterInfo[scope.displayIdField] = scope.filter.text;
                }
                if(scope.displayExtraField){
                    filterInfo[scope.displayExtraField] = scope.filter.text;
                }
                scope.filteredList = $filter('searchFilter')(scope.data, filterInfo, true);

                
                highlightIndex(0);

                if(scope.defaultOpt){
                    scope.filteredList.unshift(scope.defaultItem);
                    highlightIndex(1);
                }
            };

            scope.toggleOpen = function(){
                if(scope.ngDisabled) { return; }

                if(scope.isOpen){ close(); }
                else { open(); }
            };
            
            /**
             * Setting listeners to close when the main element lose focus
             */
            $timeout(function () {
                mainElement.addEventListener('focus',focusEvent,true);
                mainElement.addEventListener('blur',blurEvent,true);
            });
            element.on('keydown', 
                manageKeydown
            ); 
            scope.$watchCollection('data',
                scope.filterData
            );
            
            /**
             * Watching the selected item:
             *  - ngChange callback
             */
            scope.$watch('ngModel', function (newSelected, oldSelected) {
                    /* jshint maxcomplexity:false */
                //If its an entity we show the create/link buttons
                //console.log(scope.labelText + 'watch ngmodel');
                //console.log(newSelected);
                //console.log(oldSelected);
                element.removeClass('add-icon');
                    if(!scope.isSelected()){
                        if(scope.entityCreate){ element.addClass('add-icon'); } 
                    }else{
                        if(scope.entityEdit || scope.entityLink) { element.addClass('add-icon'); } 
                    } 

                    var newValue = newSelected ? newSelected[scope.idField] : null;
                    var oldValue = oldSelected ? oldSelected[scope.idField] : null;

                    //if((newValue == null || typeof newValue === 'undefined') && (oldValue == null || typeof oldValue === 'undefined')){
                    //    return;
                    //}

                    var index = indexOfById(newSelected, scope.data);
                    //if(index < 0){
                        //scope.ngModel = scope.emptyItem;//newValue ? oldSelected :  newValue;
                    if (index >= 0 && scope.data !== null) {
                        var a = scope.data[index];
                        scope.ngModel = a;
                        highlightIndex(index);
                    }

                    scope.ngModelId = scope.ngModel ? scope.ngModel[scope.idField] : null;
                    
                    if (!((newSelected === null || typeof newSelected === 'undefined') || (oldSelected === null || typeof oldSelected === 'undefined'))) {
                        if (newSelected[scope.idField] === oldSelected[scope.idField]) {
                            return;
                        }
                    }
                
                    if (scope.ngChange) {
                        $timeout(function () {
                            scope.ngChange();
                        }); //Calling ngChange callback
                    }
                    if (scope.onChange) {
                        $timeout(function () {
                            scope.onChange();
                        }); //Calling onChange callback
                    }
                },
                true
            );

            scope.$watch(
                'ngModelId',
                function (newSelected, oldSelected) {
                    if (newSelected == null) {
                        scope.ngModel = scope.emptyItem;
                    } else if(!scope.ngModel || scope.ngModel[scope.idField] !== newSelected) { 
                        scope.ngModel = { [scope.idField] : newSelected }; 
                    }
                },
                true
            );

            

            /* Private functions */
            function focusEvent(){
                scope.keepOpen = true;
                $timeout(function(){
                    scope.keepOpen = false;
                },0);
            }
            function blurEvent(){
                $timeout(function(){
                    if(!scope.keepOpen){
                        close();
                    }
                },0);
            }
            function manageKeydown (evt) {
                /* jshint maxcomplexity:false */
                var index = 0;
                switch(evt.keyCode){
                    case 40: //ARROW DOWN
                        evt.preventDefault();
                        if(!scope.isOpen){ open(); }
                        else if(scope.filteredList){
                            if(scope.highlightItem){
                                index = indexOfById(scope.highlightItem);
                                if(index < scope.filteredList.length-1){
                                    index++;
                                }
                            }
                            highlightIndex(index);
                        }
                        break;

                    case 38: //ARROW UP
                        evt.preventDefault();
                        if(!scope.isOpen){ open(); }
                        else if(scope.filteredList){
                            if(scope.highlightItem){
                                index = indexOfById(scope.highlightItem);
                                if(index > 0){
                                    index--; 
                                }
                            }
                            highlightIndex(index);
                        }
                        break;
                    
                    case 13: //ENTER
                        if(scope.highlightItem && scope.isOpen){ selectItem(scope.highlightItem); }
                        break;
                        
                    case 9: //TAB
                        if(scope.highlightItem && scope.isOpen){ selectItem(scope.highlightItem); }
                        break;
                    default:
                        if(!scope.isOpen && 
                            ((evt.keyCode <= 48 && evt.keyCode <= 57) ||
                            (evt.keyCode <= 65 && evt.keyCode <= 90) ||
                            (evt.keyCode <= 97 && evt.keyCode <= 122))){
                            var char = (65 <= evt.keyCode && evt.keyCode <= 90)? evt.keyCode+32 : evt.keyCode;
                            scope.filter.text = String.fromCharCode(char);
                            open();
                        }
                        break;
                }
                scope.$apply();
            }

            function selectItem(item) {
                if(scope.onBeforeChange){
                    scope.onBeforeChange().then(function(){
                        _selectItem(item);
                    }, function(){
                        return;
                    });
                }else{
                    _selectItem(item);
                }
            }

            function _selectItem(item) {
                highlightIndex(indexOfById(item));
                if(scope.defaultOpt && item === scope.defaultItem){
                    scope.ngModel = scope.emptyItem;
                } else{
                    scope.ngModel = item;
                }
                if(ctrls[0]){ ctrls[0].$dirty = true; }
                if(ctrls[1]){ ctrls[1].$dirty = true; }
            }

			function highlightIndex(index) {
                if (scope.filteredList !== null && typeof scope.filteredList !== 'undefined') { 
                    if (index > -1) {
                        scope.highlightItem = scope.filteredList[index];
                        moveListTo(index);
                    } else {
                        scope.highlightItem = null;
                        moveListTo(0);
                    }
                } else {
                    scope.highlightItem = null;
                }
            }
            function open(){
                if(scope.ngDisabled) { return; }

                scope.isOpen = true;

                //Timeout to wait for the DOM to render
                $timeout( function () { //Render the div
                    if(scope.isOpen){
                        element[0].querySelectorAll('input')[0].focus();
                        scope.filterData();

                        if(scope.isSelected()){
                            $timeout( function(){ //Render the list items
                                highlightIndex(indexOfById(scope.ngModel));  
                            });
                        }
                    }
                });
            }
            function close(){
                scope.isOpen = false;
                scope.filter.text = '';
            }
            function moveListTo(index){
                //var index = i+1;
                var list = element.find('ul')[0];
                if(!list || !list.children || list.children.length <= 0) { return; }
                if(index < 0 || index >= list.children.length){ return; }

                var item = list.children[index];

                var itemTop = item.offsetTop - list.offsetTop;

                //If we need to scroll up to find the item
                if(itemTop < list.scrollTop){
                    list.scrollTop = itemTop;
                }

                //If we need to scroll down to find the item
                if(itemTop + item.offsetHeight > list.scrollTop + list.clientHeight){
                    list.scrollTop = itemTop + item.offsetHeight - list.clientHeight;
                }
            }
            function indexOfById(item, list){
                if(!item) { return -1; }
                if(!list) { list = scope.filteredList; }
                if(!list) { return -1; }
                var value = item[scope.idField];
                for(var i = 0; i < list.length; i += 1) {
                    if(list[i][scope.idField] === value) {
                        return i;
                    }
                }
                return -1;
            }

            scope.$on('$destroy', function() {
                mainElement.removeEventListener('focus',focusEvent,true);
                mainElement.removeEventListener('blur',blurEvent,true);
            });


            /**
             * Modal for creating entities quickly
             */
            scope.showCreateModal = function(){
                //if(scope.entityCreate){
                //    modals.showModal(scope.entityCreate, scope.entityCreateCallback);
                //}
                scope.entityCreateCall();
            };

            /**
             * Link to entity info [entityLink + '?id=' + selectedItemId]
             */
            scope.goToLink = function(){
                $state.transitionTo(scope.entityLink, {id: scope.ngModel[scope.idField]});
            }; 
        }
    }
})();